/***
**Module Name: Header 
 **File Name :  Header.js
 **Project :    Orasi Media
 **Copyright(c) : X Platform Consulting.
 **Organization : Peafowl Inc
 **author :  chandrasekhar
 **author :  Hari
 **license :
 **version :  1.0.0
 **Created on :
 **Created on: Dec 27 2022
 **Last modified on: Dec 27 2022
 **Description : contains header component details.
 ***/

import "../../assets/css/style.css"
import logo from '../../assets/images/logo.png';
import { useHistory } from "react-router-dom";
import React, { useState, useEffect, useContext } from "react";
import tmdbApi from "../../api/tmdbApi";
import { contentContext } from "../../context/contentContext";
const Header = (props) => {
  const [clientName, setClientName] = useState([]);
  const { clientInfo, setClientInfo } = useContext(contentContext);
  const history = useHistory();
  const token = localStorage.getItem("token1")

  const handleClick = (value) => {
    console.log("valueee", value)
    if (value === "login") {
      history.push("/login")
    } else if (value === "signUp") {
      history.push("/signup")
    }
  }
  useEffect(() => {
    // userName = localStorage.getItem("ClientName")?.split(" ");
    const token = localStorage?.getItem("token1")
    if (token && clientInfo) {
      setClientName(clientInfo.name?.split(" "));
    }
    // else if(clientInfo == undefined && token) {
    //   localStorage.removeItem("token1");
    //   localStorage.removeItem("clientid");
    //   localStorage.removeItem("username");
    //   history.push("/")
    // }
  }, [clientInfo]);

  const handleLogout = async () => {

    try {

      const response = await tmdbApi.Logout({
        "username": clientInfo?.username,
      });
      // console.log(response);
      // localStorage.clear()
      localStorage.removeItem("token1");
      localStorage.removeItem("clientid");
      localStorage.removeItem("username");
      history.push("/")
    } catch {
      console.log("error");
      // setBtnLoader("")
      // setError("Invalid email or password");
      // setTimeout(function () { setError("") }, 3000);
    }

  }
  // console.log("clientInfooooo",clientInfo, token)
  return (

    <header className="header">
      <div className="wrapper">
        <div className="logo">
          <img src={logo} />
        </div>
        {token ? <div className="profile">
          <div className="d-flex">
            <div className="dropdown d-inline-block">
              <button type="button" className="btn header-item waves-effect d_flex" id="page-header-user-dropdown"
                data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <span className="user-badge">{clientName && clientName.length > 1 ? clientName && clientName.length > 0 && clientName[0]?.slice(0, 1)?.toUpperCase() + clientName[1]?.slice(0, 1)?.toUpperCase()
                  : clientInfo && clientInfo.name?.slice(0, 2)?.toUpperCase()}</span>

                <i className="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
              </button>
              <div className="dropdown-menu dropdown-menu-end">

                <a className="dropdown-item" href="/clientprofile"><i className="bx bx-user font-size-16 align-middle me-1"></i>
                                 <span key="t-profile">Profile</span></a>
                                 <a className="dropdown-item" href="/quizdetails"><i className="bx bx-file font-size-16 align-middle me-1"></i>
                                 <span key="t-profile">Quiz</span></a>
                     
                <div className="dropdown-divider"></div>
                <a className="dropdown-item text-danger" onClick={handleLogout}><i
                  className="bx bx-power-off font-size-16 align-middle me-1 text-danger"></i> <span
                    key="t-logout">Logout</span></a>
              </div>
            </div>
          </div>
        </div> : <div className="d_flex">
          <button type="submit" className="border_btn mr-10" onClick={() => handleClick("login")}>Login</button>
          <button type="submit" className="vs_btn" onClick={() => handleClick("signUp")}>Sign Up</button>
        </div>}


      </div>
    </header>
  );
};

export default Header;
